// translations/pages/events/de.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPageDE = {
  title: 'Events',
  upcoming: 'Kommende Events',
  past: 'Vergangene Events',
  all: 'Alle Events',
  items: {
    wikki26: {
      title: 'WiKKI26 – Wildauer Konferenz für Künstliche Intelligenz',
      description: 'pAIoneer Labs war als Aussteller an der Technischen Hochschule Wildau vertreten. Am Stand ging es darum, wie lokale KI-Infrastrukturen in Unternehmen und Organisationen aufgebaut werden: Datensouveränität, Datenschutz by Design und rechtskonforme KI, ohne unnötige Abhängigkeit von externen Cloud-Lösungen.'
    }
  }
};
